var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { XCircle } from 'shared/assets/icons';
import { Icon, Text } from 'shared/components';
import { TrackedButton } from '../../analytics';
export var IFrameCloseButton = function (_a) {
    var disclosure = _a.disclosure, onClose = _a.onClose;
    var onClick = function () {
        disclosure.onClose();
        if (onClose) {
            onClose();
        }
    };
    return (_jsx(TrackedButton, __assign({ eventName: "Close Iframe Button", eventProperties: { spring_doc_id: 'compass044' }, rightIcon: _jsx(Icon, { as: XCircle, height: "18px", width: "18px", m: 2 }), height: "56px", m: 1, onClick: onClick, "data-testid": "iframeCloseButton" }, { children: _jsx(Text, __assign({ fontWeight: "bold", fontSize: "body1", ml: 3 }, { children: "Close Window" })) })));
};
